export {
  RelevantInterestingSection,
  type RelevantInterestingSectionProps,
  type RelevantInterestingSectionCategory,
  type RelevantInterestingSectionCardItem,
} from '../../compositions/my-trips/RelevantInterestingSection';
